var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"main-header-option"},[_c('div',{staticClass:"content-wrap"},[_c('div',{staticClass:"main-header-option-select"},[_vm._v("Workspace:  "),_c('dropdown',{attrs:{"menuitems":_vm.workspaces,"selected":_vm.workspace.name,"callback":"selectWorkspace"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }